import React, { useState } from 'react';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import BurgerIcon from '@/assets/icons/icon-buger.svg';
import CloseIcon from '@/assets/icons/icon-close-white.svg';
import { useAppSelector } from '@/hooks/redux';
import { selectIsAuth } from '@/redux/auth/authSlice';

const mobileMenuLinks = [
  {
    id: 1,
    text: 'Home',
    link: '/',
    isPrivate: false,
  },
  {
    id: 2,
    text: 'Borrow',
    link: 'loans/borrow',
    isPrivate: false,
  },
  {
    id: 3,
    text: 'Lend',
    link: 'loans/lend',
    isPrivate: false,
  },
  {
    id: 4,
    text: 'Rewards',
    link: '/rewards',
    isPrivate: false,
  },
  {
    id: 5,
    text: 'API/SDK',
    link: '/api-sdk',
    isPrivate: false,
  },
  {
    id: 6,
    text: 'Docs',
    link: 'https://docs.nettyworth.io/docs/welcome',
    newTab: true,
    isPrivate: false,
  },
  {
    id: 7,
    text: 'Telegram',
    link: 'https://t.me/+K1OvsbxoF8ozOGIx?utm_source=website&utm_medium=tmenu',
    newTab: true,
    isPrivate: false,
  },
];

const NavbarMobileMenu = () => {
  const isAuth = useAppSelector(selectIsAuth);
  const pathname = usePathname();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <button onClick={toggleMobileMenu} type='button' className='lg:hidden size-6 hover:opacity-75 active:scale-95 [&_rect]:fill-primary dark:[&_rect]:fill-white'>
        <BurgerIcon className='w-full h-full object-contain' />
      </button>

      <aside className={`lg:hidden fixed flex flex-col justify-between bg-white-100 dark:bg-jet-black z-50 h-full w-full top-0 pt-[40px] pb-6 px-[25px] transition-all duration-200 ${isMobileMenuOpen ? 'right-0' : '-right-full'}`}>
        <div>
          <div className='flex justify-between items-center gap-6'>
            {/* {!isMobileMenuOpen && (
              <div className='size-10 flex items-center justify-center rounded-full !bg-black'>
                <SettingsIcon className='[&_path]:fill-white' />
              </div>
            )} */}

            <div className='flex-1 flex items-center justify-end'>
              <button type='button' onClick={toggleMobileMenu} className='size-6 hover:opacity-75 active:scale-95 [&_rect]:fill-primary dark:[&_rect]:fill-white'>
                <CloseIcon />
              </button>
            </div>
          </div>

          <ul className='flex flex-col items-start gap-3 pt-7'>
            {mobileMenuLinks.map(({ id, link, text, newTab, isPrivate }) => (
              <Link key={id} onClick={() => setIsMobileMenuOpen(false)} href={isPrivate && !isAuth ? '/login' : link} target={newTab ? '_blank' : '_self'} className={`dark:text-white w-full text-lg rounded-[102px] font-medium py-2 px-6 ${pathname === link ? '!bg-grey-coal-50' : ''}`}>
                {text}
              </Link>
            ))}
          </ul>

          <Link href='/loans' onClick={() => setIsMobileMenuOpen(false)} className='mt-3 md:w-[342px] w-full h-[42px] rounded flex justify-center items-center [background:_linear-gradient(180deg,_rgba(243,_238,_255,_0.00)_0%,_rgba(243,_238,_255,_0.04)_100%),_#1160FF] text-white font-medium px-6 py-2 hover:opacity-75 active:scale-95'>
            Launch App
          </Link>
        </div>
      </aside>
    </>
  );
};

export default NavbarMobileMenu;
